module.exports = __webpack_public_path__ + "img/P150T_weapon_159.b21837e6.png";